import type { PageContext } from 'vike/types';
import { extractCareersSlugFromUrlPathname } from '../../../utils/careers/resolve-careers-route-slug';

/**
 * Route guard for hosted careers pages — same slashes-in-company-name reconstruction as the
 * company profile's +route.ts (the CDN pre-decodes %2F, splitting one slug into several
 * segments for names like "Astellas Pharma A/S, filial i Finland").
 */
export function route(pageContext: PageContext) {
  const pathToCheck =
    (pageContext as { urlLogical?: string; urlPathname?: string }).urlLogical ?? pageContext.urlPathname;
  if (!pathToCheck) return false;

  const slug = extractCareersSlugFromUrlPathname(pathToCheck);
  if (!slug) return false;

  return { routeParams: { companyslug: slug } };
}
